var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.unidades)+" "),_c('LineChartGenerator',{attrs:{"chart-options":_vm.chartOptionsMutado,"chart-data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }